/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    aws_project_region: 'ap-northeast-1',
    // dev
    // Auth: {
    //     identityPoolId: 'ap-northeast-1:f208892a-92c9-46c0-9da5-59e90ed45bae',
    //     identityPoolRegion: 'ap-northeast-1',
    //     // REQUIRED - Amazon Cognito Region
    //     region: 'ap-northeast-1',

    //     // OPTIONAL - Amazon Cognito User Pool ID
    //     userPoolId: 'ap-northeast-1_vdFj6DWel',

    //     // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    //     userPoolWebClientId: '1i8hcmtsqdom56oldcsd20vtg',

    //     mandatorySignIn: false,

    //     // OPTIONAL - Hosted UI configuration
    //     oauth: {
    //         domain: 'dev-iriomote-lae-users.auth.ap-northeast-1.amazoncognito.com',
    //         scope: ['profile', 'openid'],
    //         redirectSignIn: ['https://d2kpjw082nkcyt.cloudfront.net?cognito=true'],
    //         redirectSignOut: 'https://localhost',
    //         responseType: 'token',
    //     },
    // },
    // prod
    Auth: {
        identityPoolId: 'ap-northeast-1:2e658920-ff7e-4e40-b091-91216d8b6a30',
        identityPoolRegion: 'ap-northeast-1',
        // REQUIRED - Amazon Cognito Region
        region: 'ap-northeast-1',

        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'ap-northeast-1_t77cs1wWt',

        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: '5jgppi7re6gv59qnpn32fl9314',

        mandatorySignIn: false,

        // OPTIONAL - Hosted UI configuration
        oauth: {
            domain: 'prod2-iriomote-lae-users.auth.ap-northeast-1.amazoncognito.com',
            scope: ['profile', 'openid'],
            redirectSignIn: ['https://lae-iri.com?cognito=true'],
            redirectSignOut: 'https://localhost',
            responseType: 'token',
        },
    },
};

export default awsmobile;
